import {postMethod} from '~/api'

async function post(request, params) {
    return await postMethod('/api/resetPassword', request, {params})
}

export {post}
